import { styled } from "styled-components";

const BreadcrumbsList = styled.ol(() => ({
  margin: 0,
  padding: 0,
  display: "flex",
}));

export default BreadcrumbsList;
